module.exports = __webpack_public_path__ + "img/2-4.abe96bce.png";